import { render, staticRenderFns } from "./RankingPage.vue?vue&type=template&id=2e7101fc&scoped=true&"
import script from "./RankingPage.vue?vue&type=script&lang=js&"
export * from "./RankingPage.vue?vue&type=script&lang=js&"
import style0 from "./RankingPage.vue?vue&type=style&index=0&id=2e7101fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7101fc",
  null
  
)

export default component.exports